import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-document-download',
  standalone: true,
  imports: [],
  templateUrl: './icon-bold-document-download.component.html',
  styleUrl: './icon-bold-document-download.component.scss'
})
export class IconBoldDocumentDownloadComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
